<template>
  <SpringPopup
    :closable="true"
    padding="px-0 py-30 sm:py-50"
    @hide="$emit('close')"
  >
    <div class="financial-selector__popup">
      <div class="financial-selector__popup-header">
        <img
          :src="require('@/assets/svg/plaid/question.svg')"
        >
        <p class="text-xl mt-5 ml-10">
          Why do we need this?
        </p>
      </div>
      <div class="financial-selector__popup-body">
        <div
          v-for="(info,index) in information"
          :key="index"
          class="financial-selector__popup-body-item"
        >
          <FontAwesomeIcon
            icon="check"
            class="financial-selector__popup-body-icon"
          />
          <p class="font-semibold">
            {{ info }}
          </p>
        </div>
      </div>
      <div class="sm:text-center">
        <p class="opacity-70 mt-20 md:px-30">
          Connecting your primary bank account allows us to complete your application while providing you with faster and more efficient service.
        </p>
      </div>
    </div>
    <AppButton
      class="financial-selector__popup-button"
      @click="$emit('close')"
    >
      Continue
    </AppButton>
  </SpringPopup>
</template>

<script>
import { SpringPopup } from 'spring-ui'
import AppButton from '@/components/common/buttons/AppButton'

export default {
  name: 'FinancialSelectorPopup',
  components: {
    SpringPopup,
    AppButton
  },

  computed: {
    isFoundation () {
      return this.$store.getters['loans/isFoundation']
    },

    information () {
      if (this.isFoundation) {
        return [
          'To verify your income',
          'To check your eligibility',
          'To determine your payment schedule',
          'To set up pre-authorized payments'
        ]
      }
      return [
        'To verify your income',
        'To find you the lowest interest rates',
        'To set up pre-authorized payments',
        'To deposit your funds'
      ]
    }
  }
}

</script>

<style lang="scss" scoped>
.financial-selector__popup {
  @apply mx-40 sm:mx-30;

  &-header {
    @apply text-purple-500 font-heading pb-20 flex sm:mx-120 md:mx-180;
  }

  &-body {
    @apply mt-10 sm:text-center;

    &-item {
      @apply flex max-w-300 text-left py-10;

      @screen sm {
        @apply max-w-350 py-20 mx-auto;
      }
    }

    &-icon {
      @apply text-purple-500 mt-5 mr-10 sm:ml-30;
    }
  }

  &-button {
    @apply mx-40 mt-60 mb-20 md:mx-160;
  }
}
</style>
